import { gold, magenta, purple, red, volcano } from '@ant-design/colors';
import { BDO, LooseOrderSubtype, OrderType, PaymentType, PriceType } from 'types';

export enum ClientOrderPaymentState {
	unpaid = 'unpaid',
	overdue = 'overdue',
	paid = 'paid',
}

export const getReadableClientOrderPaymentState = (state: ClientOrderPaymentState) => {
	switch (state) {
		case ClientOrderPaymentState.unpaid:
			return 'Nieopłacone';

		case ClientOrderPaymentState.overdue:
			return 'Zaległe';

		case ClientOrderPaymentState.paid:
			return 'Opłacone';

		default:
			return 'Nieznany';
	}
};

export const getClientOrderColor = (order: ClientOrder) => {
	if (order.type === OrderType.classic) {
		if (order.onPlace) {
			return purple[5];
		}

		if (order.wasReplacement) {
			return gold[5];
		}

		return red[5];
	}

	if (order.type === OrderType.loose) {
		if (order.onPlace) {
			return magenta[3];
		}

		return magenta[3];
	}

	return volcano[5];
};

export interface ClientOrder {
	id: number;
	type: OrderType;
	subtype: 'delivery' | LooseOrderSubtype;
	wasReplacement: boolean;
	onPlace: boolean;
	bdo: BDO;
	wasteType: string;
	date: string;
	doneDate: string | undefined;
	address: string;
	containerId: number | undefined;
	netPrice: number;
	grossPrice: number;
	priceType: PriceType;
	wantedPaymentType: PaymentType;
	alreadyPaid: number;
	paymentState: ClientOrderPaymentState;
	invoiceDate: string | undefined;
}
